import {
    LayoutDashboard,
    Building2,
    Lightbulb,
    GraduationCap,
    Cpu,
    FolderKanban,
    ShoppingCart,
    Megaphone,
    LifeBuoy,
    Layers,
    Menu,
} from "lucide-react";

import { Link, NavLink } from "react-router-dom";

export default function Sidebar({ collapsed, setCollapsed, basePath = "/admin" }) {
    const menuGroups = [
        {
            label: null,
            items: [
                { icon: LayoutDashboard, label: "Dashboard", path: `${basePath}`, end: true },
                { icon: Cpu, label: "Experts", path: `${basePath}/machines` },
                // { icon: Lightbulb, label: "Innovators", path: `${basePath}/userdata` },
                // { icon: GraduationCap, label: "Experts", path: `${basePath}/expertsmanagement` },

                // { icon: FolderKanban, label: "Quotations", path: `${basePath}/enquiries` },
                { icon: ShoppingCart, label: "Bookings", path: `${basePath}/orders` },

                { icon: LifeBuoy, label: "Support", path: `${basePath}/support` },
                { icon: FolderKanban, label: "Reports", path: `${basePath}/reportsdata` },
            ],
        },
    ];

    return (
        <aside
            className={`
                bg-[#0f1c3f]
                text-white
                h-screen
                overflow-y-auto
                scrollbar-hide
                transition-all
                duration-300
                ${collapsed ? "w-20" : "w-72"}
            `}
        >
            <style>{`
                .scrollbar-hide::-webkit-scrollbar { display: none; }
                .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
            `}</style>

            {/* Header */}
            <div className="p-5 border-b border-white/10">
                <div className={`flex items-center ${collapsed ? "justify-center" : "justify-between"}`}>
                    <button
                        onClick={() => setCollapsed(!collapsed)}
                        className="p-2 rounded-lg hover:bg-white/10 transition"
                    >
                        <Menu size={22} />
                    </button>
                    {!collapsed && (
                        <Link to="/" className="flex items-center gap-3 cursor-pointer">
                            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
                                <Layers size={20} />
                            </div>
                            <div>
                                <h2 className="text-lg font-bold leading-tight">
                                    APIC <span className="text-cyan-400">ProtoHub</span>
                                </h2>
                                <p className="text-xs mt-1 text-gray-300 tracking-widest">
                                    ANDHRA PRADESH
                                </p>
                            </div>
                        </Link>
                    )}
                </div>
            </div>

            {/* Vendor pill — always visible, no navigation */}
            {/* Vendor pill */}
            <div className="px-3 pt-4">
                <button
                    className={`
            w-full
            flex
            items-center
            justify-center
            ${collapsed ? "px-0" : "gap-2 px-4"}
            py-3
            rounded-full
            bg-gradient-to-r
            from-blue-500
            to-cyan-400
            text-white
            font-semibold
            text-base
            shadow-sm
            hover:opacity-90
            transition
        `}
                >
                    <Building2 size={collapsed ? 22 : 18} />
                    {!collapsed && <span>Expert · Rahul</span>}
                </button>
            </div>

            {/* Menu */}
            <div className="p-3">
                {menuGroups.map((group, gIndex) => (
                    <div key={gIndex} className="mb-1">
                        {group.label && !collapsed && (
                            <p className="text-[11px] uppercase tracking-wider font-semibold text-slate-400 px-3 mt-5 mb-2">
                                {group.label}
                            </p>
                        )}
                        {group.label && collapsed && (
                            <div className="my-3 border-t border-white/10" />
                        )}

                        {group.items.map((item) => (
                            <NavLink
                                key={item.label}
                                to={item.path}
                                end={item.end}
                                className={({ isActive }) => `
                                    flex
                                    items-center
                                    ${collapsed ? "justify-center" : "gap-3"}
                                    p-3
                                    rounded-xl
                                    mb-1
                                    text-sm
                                    transition-all
                                    duration-200
                                    ${isActive
                                        ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-sm"
                                        : "text-slate-300 hover:bg-white/10 hover:text-white"
                                    }
                                `}
                            >
                                <item.icon size={collapsed ? 24 : 20} />
                                {!collapsed && (
                                    <span className="font-medium flex-1">{item.label}</span>
                                )}
                                {!collapsed && item.badge && (
                                    <span className="text-[11px] font-semibold bg-blue-500/90 text-white rounded-md px-2 py-0.5">
                                        {item.badge}
                                    </span>
                                )}
                            </NavLink>
                        ))}
                    </div>
                ))}
            </div>
        </aside>
    );
}